export enum GlobalConfigOriginEnum {
    CHARGE = 'charge',
    CHARGE_PIX = 'charge-pix',
    InterestAndFine = 'interest-and-fine',
}
